"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tagGroupClassNames: function() {
        return tagGroupClassNames;
    },
    useTagGroupStyles_unstable: function() {
        return useTagGroupStyles_unstable;
    }
});
const _react = require("@griffel/react");
const tagGroupClassNames = {
    root: 'fui-TagGroup'
};
/**
 * Styles for the root slot
 */ const useRootStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        mc9l5x: "ftuwxu6"
    },
    medium: {
        i8kkvl: "fsnqrgy"
    },
    small: {
        i8kkvl: "f1rjii52"
    },
    "extra-small": {
        i8kkvl: "f1ufnopg"
    }
}, {
    d: [
        ".ftuwxu6{display:inline-flex;}",
        ".fsnqrgy{column-gap:var(--spacingHorizontalS);}",
        ".f1rjii52{column-gap:var(--spacingHorizontalSNudge);}",
        ".f1ufnopg{column-gap:var(--spacingHorizontalXS);}"
    ]
});
const useTagGroupStyles_unstable = (state)=>{
    'use no memo';
    const styles = useRootStyles();
    const { size } = state;
    state.root.className = (0, _react.mergeClasses)(tagGroupClassNames.root, styles.base, styles[size], state.root.className);
    return state;
}; //# sourceMappingURL=useTagGroupStyles.styles.js.map
